import React from 'react';
import { useMetaPixel } from '../hooks/useMetaPixel';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { RevelationSection } from '../components/RevelationSection';
import { ValueStack } from '../components/ValueStack';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalClose } from '../components/FinalClose';
export function SalesPage() {
  useMetaPixel();
  return <div className="min-h-screen bg-[#050507] text-white font-sans selection:bg-[#0ea5e9] selection:text-white" data-id="element-158">
      <UrgencyBar data-id="element-159" />

      <main data-id="element-160">
        <HeroSection data-id="element-161" />
        <PainSection data-id="element-162" />
        <RevelationSection data-id="element-163" />
        <ValueStack data-id="element-164" />
        <PricingSection data-id="element-165" />
        <FAQSection data-id="element-166" />
        <GuaranteeSection data-id="element-167" />
        <FinalClose data-id="element-168" />
      </main>

      <footer className="py-8 text-center text-gray-600 text-sm border-t border-white/5 bg-[#050507]" data-id="element-169">
        <p data-id="element-170">
          © {new Date().getFullYear()} El Protocolo de Pausa. Todos los
          derechos reservados.
        </p>
      </footer>
    </div>;
}